import { Container, Button, Form, Alert, Tab, Tabs } from 'react-bootstrap';
import { Sida, Rubrik, Stycke, ContentWrapper } from "../ContentStyles";
import React, { useState, useEffect } from 'react';
import useBackend, { CallAPI, CallAPI_v2, SpinnerX, CallAPIGet } from '../../services/useBackend';
import "./Login.scss";
import { Branding } from '../../services/misc';
import { FaStore, FaMobileAlt } from "react-icons/fa";
import QRCode from "react-qr-code";

export default function Login() {
	const [result, setResult] = useState({});
	const [spinnerHidden, setSpinnerHidden] = useState(true);  

	const [bankIDorderRef, setBankIDorderRef] = useState('');  
	const [bankIdQRValue, setBankIdQRValue] = useState('');  
	const [activeTab, setActiveTab] = useState('..');	

	useEffect(() => {
		const interval = setInterval(async () => {
				if (bankIDorderRef!='') await updateBankID();
		}, 1000);

		return () => { clearInterval(interval); };
	}, [bankIDorderRef]);	

	async function handleAuthPassword(e) {
		e.preventDefault();
		setSpinnerHidden(false);
	
		const formData = new FormData(e.target),
			formDataObj = Object.fromEntries(formData.entries())
		var PostData = { SystemID: "NS", AuthData: formDataObj };
				
		let {result, jsondata} = await CallAPI_v2('/backend/auth/password','POST',JSON.stringify(PostData));

        if (result.error==false) {
            setResult(result);        
            setSpinnerHidden(true);
            localStorage.setItem('access_token', jsondata.access_token);

			var RedirectTo = "/start";

			if (jsondata.redirectTo!="") RedirectTo = jsondata.redirectTo;

            setTimeout(function() { window.location.href = RedirectTo; }, 1400);
        } else {
            setResult(result);
            setSpinnerHidden(true);
        }		
	}

	async function updateBankID(){
		let {result, jsondata} = await CallAPI_v2('/api/auth/BankIDAuthState/'+bankIDorderRef,'GET');
		setResult(result);	
		if (jsondata.qr_diff>30) setBankIDorderRef('');
		if (jsondata.status == "complete") {
			setBankIDorderRef('');
            localStorage.setItem('access_token', jsondata.access_token);

			var RedirectTo = "/cities";
			if (jsondata.redirectTo!="") RedirectTo = jsondata.redirectTo;

            setTimeout(function() {
              window.location.href = RedirectTo;
            }, 1400);
		}
		setBankIdQRValue(jsondata.qr_token);
	}

	async function initBankID(){
		setBankIDorderRef('');
		let formDataObj = {};
		let {result, jsondata} = await CallAPI_v2('/api/auth/BankIDAuthInit','POST',JSON.stringify(formDataObj));
		setBankIDorderRef(jsondata.orderRef);
		setResult(result);
		console.log(result)
	}

	async function handleSelect(key) {
		if (key=='bankid') {
			await setActiveTab(key);
			initBankID();				
		} else {
			setResult(result);						
		}
	}


	return (
		<ContentWrapper>
			<Container>
				<Sida>
					<div className="login-page">
						<div className="login-page__bg" aria-hidden="true"></div>

						<div className="login-page__grid">
							<div className="login-page__left">

								<h2 className="login-page__title">
									Välkommen tillbaka till
								</h2>

								<p className="login-page__subtitle">
									Logga in för att hantera dina butiker, se statistik och mycket mer.
								</p>

								<div className="login-page__features">
									<div className="login-page__featureCard">
										<div className="login-page__featureDot" aria-hidden="true"><FaStore /></div>
										<div>
											<div className="login-page__featureHeading">Administrera dina varor och butiker</div>
											<div className="login-page__featureText">Enkelt att lägga till varor eller justera priser</div>
										</div>
									</div>

									<div className="login-page__featureCard">
										<div className="login-page__featureDot" aria-hidden="true"><FaMobileAlt /></div>
										<div>
											<div className="login-page__featureHeading">Se besök och försäljning</div>
											<div className="login-page__featureText">Full kontroll i realtid</div>
										</div>
									</div>
								</div>
							</div>

							<div className="login-page__right">
								<div className="login-card">
									<div className="login-card__header">
										<h3>Logga in</h3>
										<p>Ange dina uppgifter för att fortsätta</p>
									</div>

									<Tabs defaultActiveKey="password" id="uncontrolled-tab-example" className="mb-3"  onSelect={(i)=>handleSelect(i)}>

										<Tab eventKey="password" title="Lösenord">
											<Form onSubmit={handleAuthPassword}>
												<Form.Group className="mb-3">
													<Form.Label className="FormHeaderText">Email</Form.Label>
													<Form.Control autoFocus type="email" name="username" />
												</Form.Group>

												<Form.Group className="mb-3">
													<Form.Label className="FormHeaderText">Password</Form.Label>
													<Form.Control type="password" name="password" />
												</Form.Group>

												<Form.Group className="mb-3" hidden={!result.Visible}>
													<Alert show={result.Visible} variant={result.Variant} className="FormSpace_">{result.Text}</Alert>
												</Form.Group>

												<Form.Group className="mb-3" hidden={spinnerHidden}>
													<SpinnerX />
												</Form.Group>

												<Form.Group className="mb-3">
													<Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor }} variant="primary" type="submit">Login</Button>
												</Form.Group>

												<Form.Group className="mb-3">
													<a href="/password/request/new" className="text-decoration-none" style={{ color: '#000', fontSize: '16px' }}>Glömt lösenord</a>
												</Form.Group>
											</Form>
										</Tab>

										<Tab eventKey="bankid" title="BankID"> 
											<Form>
												<Form.Group className="mb-3">
													<QRCode value={bankIdQRValue} viewBox={'0 0 512 512'} style={{ height: "auto", maxWidth: "100%", width: "256" }}></QRCode>
												</Form.Group>

												<Form.Group className="mb-3"  hidden={!result.Visible}>
													<Alert show={result.Visible} variant={result.Variant}  className="FormSpace_">{result.Text}</Alert> 
												</Form.Group>  

												<Form.Group className="mb-3"  hidden={spinnerHidden}>
													<SpinnerX />
												</Form.Group>  
                            
											</Form>				
										</Tab>

									</Tabs>
								</div>
							</div>
						</div>
					</div>
				</Sida>
			</Container>
		</ContentWrapper>
	);
}